import Vue from 'vue';
import Vuex from 'vuex';
import configuracion from './configuracion';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    configuracion,
  },
});
